import { StartReviewContent } from './Content/StartReviewContent';
import { StartReviewCTA } from './CTA/StartReviewCTA';
import { StartReviewHeader } from './Header/StartReviewHeader';

import { HeaderArrowIllustration } from '@/components/Illustrations/Illustration';

export interface SurveyReviewProps {
    onStart: () => void;
    className?: string;
    isSelfEvaluation?: boolean;
}

const SurveyReview = ({ onStart, className = '', isSelfEvaluation }: SurveyReviewProps) => {
    const pageClasses = `
        relative min-h-screen overflow-hidden
        ${className}
    `.trim();

    return (
        <div className={pageClasses}>
            <div className={'relative mx-auto flex max-w-5xl flex-col gap-10 px-6 py-14 md:gap-22'}>
                <StartReviewHeader
                    className={'md:w-1/2'}
                    isSelfEvaluation={isSelfEvaluation || false}
                />

                <HeaderArrowIllustration
                    aria-hidden
                    className={
                        'pointer-events-none absolute top-[90px] z-99 hidden h-[200px] w-[200px] -translate-x-1/2 scale-110 opacity-90 md:left-130 lg:block'
                    }
                />

                <div className={'z-10'}>
                    <StartReviewContent isSelfEvaluation={isSelfEvaluation || false} />
                </div>

                <div className={'z-10 flex justify-center'}>
                    <StartReviewCTA
                        onStart={onStart}
                        className={'md:w-1/2'}
                        isSelfEvaluation={isSelfEvaluation || false}
                    />
                </div>
            </div>
        </div>
    );
};

export default SurveyReview;
